import { createSelector } from '@reduxjs/toolkit';
import { candidateSlice } from '@containers/CandidateRegistration/slice';
const selectCandidateState = createSelector((state) => state, (state) => state[candidateSlice.name]);
export const selectCandidate = createSelector(selectCandidateState, (state) => state.candidate);
